<template>
  <table class="government-resolutions-data-table">
    <caption class="sr-only">
      {{
        $texts(
          'governmentResolutions.informationAboutGovernmentMeetings',
          'Behandelt an den folgenden Sitzungen: Informationen zu den Sitzungen zum Geschäft',
        )
      }}
    </caption>
    <tbody>
      <tr>
        <th>
          {{ $texts('governmentResolutions.meetingFrom', 'Sitzung vom') }}
        </th>
        <td class="text-left py-5 align-top">
          {{ agendaMeeting.meetingDate.asString }}
        </td>
      </tr>
      <tr>
        <th>
          {{ $texts('governmentResolutions.agendas', 'Traktanden') }}
        </th>
        <td>
          {{ agendaMeeting.title }}
        </td>
      </tr>
      <tr>
        <th>
          {{ $texts('governmentResolutions.documents', 'Dokumente') }}
        </th>
        <td class="text-left py-5 align-top">
          <ul v-if="agendaMeeting.documents.length > 0">
            <li v-for="document in agendaMeeting.documents" :key="document.id">
              <a
                :href="
                  buildDocumentDownloadUrl(
                    document.id,
                    document.version,
                    document.view,
                  )
                "
                class="text-primary-600 hover:underline"
                target="_blank"
              >
                {{ document.date }} {{ document.title }} ({{
                  document.extensionUpper
                }})
                <span class="sr-only">
                  {{
                    $texts(
                      'accessibility.externalLinkText',
                      'Externer Link, wird in einem neuen Tab oder Fenster geöffnet',
                    )
                  }}
                </span>
              </a>
            </li>
          </ul>
          <template v-else>
            {{ $texts('governmentResolutions.noDocuments', 'Keine') }}
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts" setup>
import type { AgendaMeeting } from '~/layers/government-resolutions/types'

defineProps<{
  agendaMeeting: AgendaMeeting
  caption?: string
}>()

function buildDocumentDownloadUrl(
  documentId: string,
  version: string,
  view: string,
): string {
  return `/api/government-resolutions/document/${documentId}/${version}/${view}`
}
</script>

<style lang="postcss">
@import '~/assets/css/components/sections/government-resolutions-data-table.css';
</style>
